var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90144 8.32529C5.91313 8.34023 5.92807 8.35231 5.94513 8.36062C5.96218 8.36893 5.98091 8.37325 5.99988 8.37325C6.01885 8.37325 6.03757 8.36893 6.05463 8.36062C6.07168 8.35231 6.08662 8.34023 6.09832 8.32529L7.84832 6.11122C7.91238 6.02997 7.85457 5.90966 7.74988 5.90966H6.59207V0.622162C6.59207 0.553412 6.53582 0.497162 6.46707 0.497162H5.52957C5.46082 0.497162 5.40457 0.553412 5.40457 0.622162V5.9081H4.24988C4.14519 5.9081 4.08738 6.02841 4.15144 6.10966L5.90144 8.32529ZM11.7186 7.77841H10.7811C10.7124 7.77841 10.6561 7.83466 10.6561 7.90341V10.3097H1.34363V7.90341C1.34363 7.83466 1.28738 7.77841 1.21863 7.77841H0.281128C0.212378 7.77841 0.156128 7.83466 0.156128 7.90341V10.9972C0.156128 11.2737 0.379565 11.4972 0.656128 11.4972H11.3436C11.6202 11.4972 11.8436 11.2737 11.8436 10.9972V7.90341C11.8436 7.83466 11.7874 7.77841 11.7186 7.77841Z",
    fill: "black",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.e10ee0d6fdd7d590016edad3c1906f83.svg";
export { ForwardRef as ReactComponent };